"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactInstantsearchCore = require("react-instantsearch-core");

var _VoiceSearch = _interopRequireDefault(require("../components/VoiceSearch"));

var _default = (0, _reactInstantsearchCore.connectSearchBox)(_VoiceSearch.default);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/widgets/VoiceSearch.js
// module id = 1114
// module chunks = 142807904292071